var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.resourceContainer},[_c('DropDownMenu',{class:_vm.$style.reportDropDownMenu,attrs:{"isFilterDropDown":true,"isLargeDropDown":false,"leftAlignList":true,"menuSections":_vm.menuSections,"menuTitle":_vm.currentReportTitle || '',"menuFontSize":"small","showMenuLabel":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }